import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [

  {
    path: '/',
    name: 'home',
    component: HomeView
  },

  {
    path: '/favorite',
    name: 'favorite',
    component: () => import('../views/FavoriteView.vue')
  },

  {
    path: '/category',
    name: 'category',
    component: () => import('../views/CategoryView.vue')
  },

  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },

  {
    path: '/product',
    name: 'product',
    component: () => import('../views/ProductView.vue')
  }


]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
